import urlUtils from '../utils/rbmc.url-utils.js';
import logger from '../utils/rbmc.logger';
import cartTracking from '../tracking/rbmc.tracking.cart';
import consumerEvents from '../events/rbmc.events.consumer-events'
import spinner from '../utils/rbmc.spinner';

const removeCartItem = {

    bindHandler() {
        $(document.body).on('click', '.cart-entry__delete-link', function (evt) {
            let entryNumber = $(this).data('entry-number');
            evt.preventDefault();
            removeCartItem.removeItemFromCart(entryNumber);
        });
    },

    removeItemFromCart(entryNumber) {
        let removeEntryUrl = urlUtils.getBaseUrl() + 'cart/removeCartItem/' + entryNumber;

        spinner.spinnerVisibility(true);
        $.post(removeEntryUrl)
         .done(function (data) {
             if (data.success) {
                 //track consumer event
                 consumerEvents.trackRemoveFromCartEvent(data.trackingProductData);
                 //track GTM dataLayer
                 cartTracking.removeFromCart(data.gtmProductData, data.gtmProductData.quantity);
                 logger.log('Success deleting item');
                 setTimeout(() => {
                     window.location.reload();
                 }, 250);
             } else {
                 logger.error('Failed to delete item');
             }

         }).fail(function (x, e) {
            logger.error('Updating item quantity failed');
            window.location.reload();
        }).always(() => {
            spinner.spinnerVisibility(false);
        });
    }
};

$(() => {
    if ($('#cart-page').length) {
        removeCartItem.bindHandler();
    }
});

export default removeCartItem;
